import { render, staticRenderFns } from "./ActiveBusiness.vue?vue&type=template&id=1d384934"
import script from "./ActiveBusiness.vue?vue&type=script&lang=js"
export * from "./ActiveBusiness.vue?vue&type=script&lang=js"
import style0 from "./ActiveBusiness.vue?vue&type=style&index=0&id=1d384934&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports